 import lang from './lang';
 import langCN from './lang_cn';

 export default {
   'en-us':lang,
   'zh-cn':langCN
 }


// WEBPACK FOOTER //
// ./example/app/resource/lang/index.js